import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import {IState, logoutRequest, snackbarSetRequest} from 'study_reviewer/store'

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
  onWillMount: () => void
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

class LogoutPage extends React.Component<IProps, {}> {
  public componentWillMount() {
    this.props.onWillMount()
  }

  public render() {
    // Wait until we are logged out to redirect back to login.
    // Especially important since login has redirect logic if the user is logged in.
    if (this.props.isLoggedIn) return null

    return (
      <Redirect to='login' />
    )
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

const mapDispatchToProps = (dispatch: Dispatch<void>) => ({
  onWillMount: () => {
    dispatch(logoutRequest())
    // TODO I18N
    dispatch(snackbarSetRequest('You have logged out successfully!'))
  },
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(
    mapStateToProps,
    mapDispatchToProps,
  )(LogoutPage),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/LogoutPage.tsx